import type { UISchemaElement } from "@jsonforms/core";

type ReviewLayout = UISchemaElement & {
  scope?: string;
  elements?: ReviewLayout[];
  options?: { detail?: ReviewLayout; [key: string]: unknown };
};

/** Hide feedback items 8 and 16 until the decision in issue #271. Keep the catalog intact. */
export function hideDeferredReviewFields(layout: UISchemaElement): UISchemaElement {
  const hiddenScopes = new Set([
    "#/properties/death/properties/cause_of_death_sr_no",
    "#/properties/parts",
  ]);
  const visit = (node: ReviewLayout): ReviewLayout | null => {
    if (node.scope && hiddenScopes.has(node.scope)) return null;
    const result = { ...node };
    if (node.elements) {
      result.elements = node.elements.map(visit).filter((child): child is ReviewLayout => child !== null);
      if (!result.elements.length) return null;
    }
    if (node.options?.detail) {
      const detail = visit(node.options.detail);
      if (detail) result.options = { ...node.options, detail };
    }
    return result;
  };
  return visit(layout as ReviewLayout) ?? { type: "VerticalLayout", elements: [] };
}
